import { PrehledPov } from './prodej';
import { SkladOjetychVozu } from './skladOjetychVozu';
import { DokladyOjetychVozu } from './dokladyPov';

export const menu = {
	name: 'OV_OjeteVozy',
	list: [
		{ name: 'Skladov', route: SkladOjetychVozu.name },
		{ name: 'PrehledPov', route: PrehledPov.name },
		{ name: 'DokladyOv', route: DokladyOjetychVozu.name },
	],
};
